import { render, staticRenderFns } from "./NotificationCell.vue?vue&type=template&id=4b3d0ffc&scoped=true&"
import script from "./NotificationCell.vue?vue&type=script&lang=js&"
export * from "./NotificationCell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCell.vue?vue&type=style&index=0&id=4b3d0ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d0ffc",
  null
  
)

export default component.exports